import { useInfiniteQuery } from "react-query";
import { ForumPostService } from "../../types/services/forum/ForumService";
import { db } from "../../services/firebase";
import { applyVariablesToQuery } from "../../services/db";
import { EForumTopic, FORUMS_POST_TIMESTAMP_FIELD, FORUMS_TOPIC_FIELD } from "../../types/db";

/** Maximum reply per page (for pagination) */
const POSTS_PER_PAGE = 5;

export const useForumPosts = (topic?: EForumTopic, limit: number = POSTS_PER_PAGE) => {
    //fetch list of posts
    const { data, ...restData } = useInfiniteQuery(
        ["forum", "posts"],
        ({ pageParam }) => new ForumPostService(db)
            .paginate(
                limit,
                (collection) => {
                    return applyVariablesToQuery(collection,
                        {
                            orderBy: { field: FORUMS_POST_TIMESTAMP_FIELD, dir: 'desc' },//most recent first
                            where: [
                                {
                                    fieldPath: FORUMS_POST_TIMESTAMP_FIELD,
                                    opStr: '<=',
                                    value: Date.now(),
                                },
                                {
                                    fieldPath: FORUMS_TOPIC_FIELD,
                                    opStr: '==',
                                    value: topic,
                                }
                            ]
                        })
                },
                pageParam
            ),
        {
            enabled: !!topic,//only want the list of post if in a specific topic,
            getNextPageParam: (_, pages) => {
                if (!pages?.length)
                    return undefined
                const lastPage = pages[pages.length - 1];
                if (lastPage.documents.length < limit) {
                    //if last page was not fetching a complete page, we don't have more to fetch
                    return undefined;
                }
                return lastPage.lastDoc;//the last item of the last page
            },
            refetchOnWindowFocus: false,
        }
    );

    return {
        ...restData,
        data: data?.pages.flatMap((page) => page.documents),
    }
}